/* joacă bună — reveal blând la scroll, fallback IntersectionObserver (v2).
   Rulează DOAR unde animation-timeline: view() lipsește (Safari/Firefox) și
   doar fără prefers-reduced-motion. CSS-ul pereche: jb-motion.css (html.jb-io).
   Elementele deja în viewport primesc .jb-in sincron → zero flash la încărcare. */
(() => {
  'use strict';
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (window.CSS && CSS.supports('animation-timeline: view()')) return;
  if (!('IntersectionObserver' in window)) return;

  const SELECTOR = [
    '.jb-reveal',
    '.jb-section-head',
    '.jb-worldmap__cell',
    '.jb-valueprops__item',
    '.jb-testimonials__card',
    '.jb-brandstory__media',
    '.jb-brandstory__copy',
    '.jb-card-product',
    '.jb-article__tldr',
    '.jb-imprint-divider',
    '.jb-trustband--live .jb-trustband__icon',
    '.jb-finder__icon',
  ].join(',');

  const start = () => {
    const els = document.querySelectorAll(SELECTOR);
    if (!els.length) return;
    document.documentElement.classList.add('jb-io');
    const io = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            entry.target.classList.add('jb-in');
            io.unobserve(entry.target);
          }
        }
      },
      { rootMargin: '0px 0px -8% 0px' }
    );
    const vh = window.innerHeight;
    els.forEach((el) => {
      if (el.getBoundingClientRect().top < vh * 0.92) {
        el.classList.add('jb-in'); /* deja vizibil → nu-l ascunde */
      } else {
        io.observe(el);
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
